import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Act1, Act2, Act3 } from 'game/scenes';
import ROUTES from 'constants/ROUTES';

import GameService from 'services/Game.service';
import LandbotService from 'services/Landbot.service';
import VariablesService from 'services/Variables.service';
import { Layout, Game, Landbot, NativeLandbot } from 'components';
import useActsManager from 'hooks/useActsManager';

export default function GamePage() {
  return (
    <GameService>
      <LandbotService>
        <VariablesService>
          <Switch>
            <Route exact path={ROUTES.GAME.ACT_4}>
              <NativeLandbot
                config={{
                  configUrl:
                    'https://chats.landbot.io/v2/H-739061-AJGWOLIPECZ5JF9P/index.json',
                }}
              />
            </Route>
            <Route>
              <Layout>
                <Switch>
                  <Route exact path={ROUTES.GAME.ACT_2}>
                    <Landbot
                      key={2}
                      mode="click"
                      config={{
                        configUrl:
                          'https://chats.landbot.io/v2/H-737709-RUCBCRK6SI07R76X/index.json',
                      }}
                    />
                  </Route>
                  <Route exact path={ROUTES.GAME.ACT_3}>
                    <Landbot
                      key={3}
                      mode="click"
                      config={{
                        configUrl:
                          'https://chats.landbot.io/v2/H-737738-LX31FGCGOS15AYAK/index.json',
                      }}
                    />
                  </Route>
                  <Route path={[ROUTES.GAME.ROOT, ROUTES.GAME.ACT_1]}>
                    <Landbot
                      key={1}
                      mode="click"
                      config={{
                        configUrl:
                          'https://chats.landbot.io/v2/H-737659-KFM92QCM2FHAXX5P/index.json',
                      }}
                    />
                  </Route>
                </Switch>
                <Game
                  config={{
                    scene: [Act1, Act2, Act3],
                  }}
                />
              </Layout>
            </Route>
          </Switch>
          <ActsManager />
        </VariablesService>
      </LandbotService>
    </GameService>
  );
}

function ActsManager() {
  useActsManager();

  return null;
}
